module.exports = __webpack_public_path__ + "media/images/icons/country_flags/mp-353753fc1862dd16b40025358465eb99.svg";